import { FileSharingRestService, newGenericRestRequest } from './restServices';
import storageService from '../storageService';
import VIDABOO_CONSTANTS from '../../config/consts';
import httpService from './httpService';

const service = {};

service.saveFileMessageByChatRoomId = async (
  senderObjectType,
  senderObjectId,
  chatRoomId,
) => {
  let currentTime = new Date();
  let mediaMessageDto = {};
  mediaMessageDto.senderObjectType = senderObjectType;
  mediaMessageDto.senderObjectId = senderObjectId;
  mediaMessageDto.chatRoomId = chatRoomId;
  mediaMessageDto.senderCreationTime = currentTime.getTime();
  // mediaMessageDto.mediaType = VIDABOO_CONSTANTS.MEDIA_MESSAGE_TYPES.OTHER;

  try {
    const response = await FileSharingRestService.save(
      {
        endpoint: 'roomId',
        endpointParam: chatRoomId,
      },
      { ...mediaMessageDto, token: storageService.getItem('token') },
    );
    if (response.status === 200) {
      //   sendAudioMessageNotification(response.data.mmDto.mediaMessageId);
      return response;
    }
  } catch (error) {
    console.debug(error);
  }
};

service.uploadFileToS3 = async (
  base64,
  tempAccessUrl,
  progress,
  cancelTokenCallback,
) => {
  // console.debug('base64base64', base64);
  // console.debug('tempAccessUrl', tempAccessUrl);

  // console.debug('progress', progress);
  // console.debug('cancelTokenCallback', cancelTokenCallback);
  try {
    const cancelTokenSource = httpService.cancelToken.source();
    cancelTokenCallback(cancelTokenSource);
    const response = await newGenericRestRequest(
      'put',
      VIDABOO_CONSTANTS.MEDIA_MESSAGES_STORAGE + tempAccessUrl,
      base64,
      {
        onUploadProgress: (progressEvent) =>
          progress(
            ((progressEvent.loaded / progressEvent.total) * 100).toFixed(2),
          ),
        cancelToken: cancelTokenSource.token,
      },
    );
    console.debug('uploadFileToS3responseresponse', response);
    if (response.status === 200) {
      return true;
    }
    return false;
  } catch (error) {
    console.debug('uploadFileToS3errorerror', error);

    console.debug(error, 'Error in uploading file');
  }
};

service.saveConfirmedFile = async (
  mediaMessageId,
  saveConfirmed,
  fileName,
  fileSize,
  fileType,
) => {
  const mediaMessageDto = {
    mediaMessageId,
    saveConfirmed,
    fileName,
    fileSize,
    fileType,
  };
  try {
    const response = await FileSharingRestService.save(
      {
        endpoint: 'saveConfirmed',
        endpointParam: mediaMessageId,
      },
      { ...mediaMessageDto, token: storageService.getItem('token') },
    );
    if (response.status === 200) {
      //   sendAudioMessageNotification(response.data.mmDto.mediaMessageId);
      return response;
    }
  } catch (error) {
    console.debug(error);
  }
};

service.getFileByMsgId = async (fileMsgId) => {
  try {
    const response = await FileSharingRestService.get(
      {
        endpoint: 'mediaMessageId',
        endpointParam: fileMsgId,
        endpoint2: 'userId',
        endpointParam2: storageService.getItem('guestUid'),
      },
      { token: storageService.getItem('token') },
    );
    return response;
  } catch (error) {
    console.debug(error);
  }
};

const fileSharingService = { ...service };
export default fileSharingService;
